import { useState, useEffect, useCallback } from "react";
import { getLocations } from "../services/careManagerDataService";

const STORAGE_KEY = "mcm_selected_location";

/**
 * Hook para selección de location del Care Manager Dashboard.
 * Misma lógica que useLocationSelector pero usa datos del CM data service.
 *
 * @returns {{ locations: Array, selectedLocation: Object|null, setSelectedLocation: Function, loading: boolean }}
 */
export default function useCMLocationSelector() {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocationState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadLocations() {
      try {
        const locs = await getLocations();
        if (cancelled) return;

        setLocations(locs);

        // Restaurar selección de localStorage o usar la primera
        const savedKey = localStorage.getItem(STORAGE_KEY);
        const saved = locs.find((l) => l.key === savedKey);
        setSelectedLocationState(saved || locs[0] || null);
      } catch (err) {
        console.error("Error loading CM locations:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadLocations();
    return () => { cancelled = true; };
  }, []);

  const setSelectedLocation = useCallback((location) => {
    setSelectedLocationState(location);
    if (location?.key) {
      localStorage.setItem(STORAGE_KEY, location.key);
    }
  }, []);

  return { locations, selectedLocation, setSelectedLocation, loading };
}
